/**
 * Pricing query key factory
 */
export const pricingKeys = {
  all: ["pricing"] as const,

  // Product pricing
  productPrices: () => [...pricingKeys.all, "product"] as const,
  productPrice: (productId: string) =>
    [...pricingKeys.productPrices(), productId] as const,

  // Partner pricing
  partnerPrices: () => [...pricingKeys.all, "partner"] as const,
  partnerPrice: (partnerId: string) =>
    [...pricingKeys.partnerPrices(), partnerId] as const,

  // Client group pricing
  clientGroupPricesAll: () => [...pricingKeys.all, "client-group"] as const,
  clientGroupPrices: (groupId: string) =>
    [...pricingKeys.clientGroupPricesAll(), groupId] as const,

  // Effective price
  effectivePrice: (productId: string, partnerId: string) =>
    [...pricingKeys.all, "effective", productId, partnerId] as const,

  // Effective partner prices (all products for a partner)
  effectivePartnerPrices: (partnerId: string) =>
    [...pricingKeys.all, "effective-partner", partnerId] as const,

  // Company-level global cache keys
  companyPartnerPricesGlobal: () =>
    ["pricing", "partner-prices", "global"] as const,
  companyGroupPricesGlobal: () =>
    ["pricing", "group-prices", "global"] as const,

  // User-scoped global cache keys
  userPartnerPricesGlobal: (userId: string) =>
    ["pricing", "partner-prices", "global", "user", userId] as const,
  userGroupPricesGlobal: (userId: string) =>
    ["pricing", "group-prices", "global", "user", userId] as const,
} as const;
